import React, { useEffect, useState, useRef } from "react";
import ReusableTable from "../components/ReusableTable";
import { getApiUrl } from "../utils/api";
import { BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

const Ordermanagement = () => {
  const [orders, setOrders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filterDate, setFilterDate] = useState("");
  const invoiceRef = useRef(null);
  const navigate = useNavigate();
  const UserId = "66abc123def4567890abcd12";

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalOrders, setTotalOrders] = useState(0);
  const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

  const fetchOrders = async (page = 1) => {
    try {
      const res = await fetch(getApiUrl(`order-success?page=${page}`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      const data = await res.json();
      if (data.success) {
        setOrders(data.data);
        setCurrentPage(data.pagination.currentPage);
        setTotalPages(data.pagination.totalPages);
        setTotalOrders(data.pagination.totalOrders); // ✅ important for Si No
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

useEffect(() => {
  let result = [...orders];

  // Search filter
  if (search) {
    const term = search.toLowerCase().trim();
    result = result.filter(
      (o) =>
        (o?.userId?.name || "guest").toLowerCase().includes(term) ||
        (o?.orderUnique || "").toLowerCase().includes(term)
    );
  }

  if (startDate || endDate) {
  // Helper: convert date string to "YYYY-MM-DD"
  const getDateStr = (d) => new Date(d).toISOString().slice(0, 10);

  const from = startDate ? getDateStr(new Date(startDate)) : null;
  const to   = endDate   ? getDateStr(new Date(endDate)) : null;

  result = result.filter((o) => {
    const orderDate = getDateStr(o.createdAt);

    if (from && to) {
      return orderDate >= from && orderDate <= to;
    }
    if (from) {
      return orderDate >= from;
    }
    if (to) {
      return orderDate <= to;
    }
    return true;
  });
}

  setFiltered(result);
}, [search, orders, startDate, endDate]);

  const handleShipChange = async (orderId, status) => {
    try {
      const res = await fetch(getApiUrl(`order/ship-status/${orderId}`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shipStatus: status }),
      });
      const data = await res.json();
      if (data.success) {
        toast.success("Shipping status updated");
        fetchOrders();
      } else toast.error("Failed to update");
    } catch {
      toast.error("Server error");
    }
  };

const sendWhatsApp = (row) => {
  const phone = row?.userId?.phone;

  if (!phone) {
    alert("Customer phone number not available");
    return;
  }

  const confirmSend = window.confirm(
    `Send shipping message to ${row?.userId?.name || "Customer"}?`
  );
  if (!confirmSend) return;

  const productList = row.products
    .map((p, i) => {
      const name = p.productId?.productName || p.name || "Product";
      return `${i + 1}. ${name} | Size: ${p.size} | Qty: ${p.qty}`;
    })
    .join("\n");

  const message = `
Hello ${row?.userId?.name || "Customer"},

Your order has been shipped successfully.

Order ID: ${row.orderUnique || "N/A"}

Products:
${productList}

Total Amount: ₹${row.amount}

👉🏼 You will get the parcel within 3 to 6 working days

⚠️ Strictly No return / No exchange on quality basis, Size, and colour variation.

⚠️ Must need unboxing video for any damage otherwise we never take return.

🙏🏼 Thanks for dealing with us ❤
`.trim();

  const formattedPhone = phone.replace(/\D/g, "");
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${formattedPhone}?text=${encodedMessage}`;

  window.open(url, "_blank");
};
  const tinyView = {
    padding: "2px 6px",
    fontSize: "11px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    background: "#f5f5f5",
    cursor: "pointer",
    lineHeight: "1.2",
  };

  const tinyWhatsapp = {
    padding: "2px 6px",
    fontSize: "11px",
    borderRadius: "4px",
    border: "none",
    background: "#25D366",
    color: "#fff",
    cursor: "pointer",
    lineHeight: "1.2",
  };

  const columns = [
    {
      name: "Si No",
      selector: (row, index) => filtered.length - index,
      width: "80px",
    },
    {
      name: "Order Ref",
      cell: (row) => (
        <span
          style={{
            background: "#eef2ff",
            color: "#4338ca",
            padding: "2px 6px",
            borderRadius: "4px",
            fontSize: "11px",
            fontWeight: 600,
          }}
        >
          {row.orderReference || "-"}
        </span>
      ),
      width: "140px",
    },
    {
      name: "Product Name",
      cell: (row) => (
        <ul
          className="list-unstyled mb-0"
          style={{ maxHeight: "80px", overflow: "auto" }}
        >
          {row.products.map((p, idx) => (
            <li key={idx} style={{ fontSize: "13px", lineHeight: "1.3" }}>
              {p.productInfo?.productName || p.name || "-"}
            </li>
          ))}
        </ul>
      ),
      width: "180px",
    },
    {
      name: "Subcategory",
      cell: (row) => (
        <ul
          className="list-unstyled mb-0"
          style={{ maxHeight: "60px", overflow: "auto", fontSize: "12px" }}
        >
          {row.products.map((p, idx) => (
            <li key={idx}>{p.productInfo?.subcategory || "-"}</li>
          ))}
        </ul>
      ),
      width: "140px",
    },
    {
      name: "Image",
      cell: (row) => (
        <div
          className="d-flex gap-1 flex-wrap"
          style={{
            maxHeight: "70px",
            overflow: "auto",
            flexWrap: "nowrap", // ✅ Add this for horizontal scroll
            maxWidth: "100%", // ✅ Ensure it fits column
          }}
        >
          {row.products.map((p, idx) => {
            // ✅ Remove slice(0, 3) to show ALL
            const image = p.productInfo?.mainImage;
            if (!image) return null;
            return (
              <img
                key={idx}
                src={`${BASE_URL}${image}`}
                width="40"
                height="40"
                style={{
                  objectFit: "cover",
                  borderRadius: "4px",
                  border: "1px solid #e0e0e0",
                  flexShrink: 0, // ✅ Prevent image shrinking
                }}
                onError={(e) => (e.target.style.display = "none")}
                alt="Product"
              />
            );
          })}
        </div>
      ),
      width: "160px",
      allowOverflow: true,
    },

    {
      name: "Quantity",
      selector: (row) => {
        const totalQty = row.products.reduce((sum, p) => sum + (p.qty || 0), 0);
        return totalQty;
      },
      width: "90px",
    },
    {
      name: "Size",
      cell: (row) => (
        <ul
          className="list-unstyled mb-0"
          style={{ fontSize: "12px", maxHeight: "60px", overflow: "auto" }}
        >
          {row.products.map((p, idx) => (
            <li key={idx}>{p.size}</li>
          ))}
        </ul>
      ),
      width: "100px",
    },
    {
      name: "Customer",
      selector: (row) => row?.userId?.name || "Guest",
      width: "140px",
    },
    {
      name: "Amount",
      selector: (row) => `₹${row.amount}`,
      width: "110px",
    },
    {
      name: "Status",
      cell: (row) => {
        let badgeClass = "";
        switch (row.paymentStatus) {
          case "SUCCESS":
            badgeClass = "bg-success";
            break;
          case "PENDING":
            badgeClass = "bg-warning text-dark";
            break;
          case "FAILED":
            badgeClass = "bg-danger";
            break;
          default:
            badgeClass = "bg-secondary";
        }
        return (
          <span className={`badge ${badgeClass}`}>{row.paymentStatus}</span>
        );
      },
      width: "110px",
    },
    {
      name: "Order ID",
      cell: (row) => (
        <span
          style={{
            background: "#dcfce7",
            color: "#166534",
            padding: "2px 6px",
            borderRadius: "4px",
            fontSize: "11px",
            fontWeight: 600,
          }}
        >
          {row.orderUnique || "-"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Shipping",
      cell: (row) => (
        <select
          className="form-select form-select-sm"
          value={row.shipStatus || "processing"}
          onChange={(e) => handleShipChange(row._id, e.target.value)}
          style={{ fontSize: "12px", padding: "2px 4px" }}
        >
          <option value="processing">Processing</option>
          <option value="shipped">Shipped</option>
        </select>
      ),
      width: "120px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "4px", fontSize: "12px" }}>
          <button onClick={() => setSelectedOrder(row)} style={tinyView}>
            View
          </button>
          <button onClick={() => sendWhatsApp(row)} style={tinyWhatsapp}>
            WA
          </button>
        </div>
      ),
      width: "100px",
      right: true,
    },
  ];

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[d.getMonth()];
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const renderOrderHTML = (order) => `
<style>
* {
  box-sizing: border-box;
  font-family: "Segoe UI", Arial, Helvetica, sans-serif;
}

body {
  margin: 0;
  padding: 0;
}

/* A4 PAGE */
.page {
  width: 210mm;
  min-height: 297mm;
  max-height: 297mm;
  padding: 15mm;
  overflow: hidden;
  display: flex;
  justify-content: center;
  background: #fff;
}

/* MAIN BOX */
.container {
  width: 100%;
  height: 100%;
  border: 3px solid #000;
  padding: 22px 26px;
  display: flex;
  flex-direction: column;
}

/* HEADER */
h2 {
  margin: 0 0 12px 0;
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-align: center;
}

/* SECTIONS */
.section {
  font-size: 20px;
  border-top: 3px solid #000;
  padding-top: 10px;
  margin-bottom: 12px;
  line-height: 1.5;
}

/* TITLES */
.section-title {
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 6px;
  text-transform: uppercase;
}

/* TABLE */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 20px;
}

th {
  border: 2.5px solid #000;
  padding: 8px;
  background: #f0f0f0;
  font-weight: 900;
  text-align: center;
}

td {
  border: 2px solid #000;
  padding: 8px;
  text-align: center;
}

td:first-child {
  text-align: left;
}

/* PUSH TOTAL TO BOTTOM */
.total {
  font-size: 28px;
  text-align: right;
  border-top: 4px solid #000;
  padding-top: 14px;
  margin-top: auto;
  font-weight: 900;
}

/* FOOTER */
.thank-you {
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  border-top: 2px solid #000;
  padding-top: 10px;
  margin-top: 10px;
}

/* TO ADDRESS HIGHLIGHT */
.to-address {
  border: 4px solid #000;
  padding: 12px;
  margin-top: 8px;
  background: #f9f9f9;
}

.to-address .name {
  font-size: 32px;
  font-weight: 1000;
  letter-spacing: 1px;
}

.to-address .line {
  font-size: 22px;
  font-weight: 700;
}
</style>

<div class="page print-page">
  <div class="container">

    <div class="logo">
      <img src="${window.location.origin}/image/boutique.jpg" crossorigin="anonymous" />
      <h2>BSK Boutique</h2>
    </div>

    <div class="section">
      <div class="section-title">Order Details</div>
      Order Date: ${formatDate(order.createdAt)}<br/>
    
    </div>

    <div class="section">
     

      <strong>FROM:</strong><br/>
      BSK Boutique, Rajapalayam, Tamil Nadu<br/>
      +91 90256 76315<br/><br/>

      <strong>TO:</strong>
      <div class="to-address">
        <div class="name">
          ${order?.userId?.name || "Guest"}
        </div>
        <div class="name">
          ${order?.address?.address || ""}
        </div>
        <div class="name">
          ${order?.address?.district || ""}, ${order?.address?.state || ""}
        </div>
        <div class="name">
          Pin: ${order?.address?.pincode || "-"}
        </div>
        <div class="name">
          Ph: ${order?.userId?.phone || "-"}
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">Products</div>
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Size</th>
            <th>₹</th>
          </tr>
        </thead>
        <tbody>
          ${order.products
            .map(
              (p) => `
            <tr>
              <td>${p.name}</td>
              <td style="text-align:center;">${p.qty}</td>
              <td style="text-align:center;">${p.size}</td>
              <td>${p.price}</td>
            </tr>
          `,
            )
            .join("")}
        </tbody>
      </table>
    </div>

    <div class="total">
      TOTAL: ₹${order.amount}
    </div>

    <div class="thank-you">
      Thank you for purchasing from BSK Boutique!
    </div>

  </div>
</div>
`;

  const printOrDownloadBulk = async (ordersList, isPdf = false) => {
    if (!ordersList.length) return toast.error("No orders found");

    /* =========================
     PRINT MODE (A4 CLEAN)
     ========================= */
    if (!isPdf) {
      const w = window.open("", "_blank");

      w.document.write(`
      <html>
        <head>
          <title>Print Orders</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              font-family: Arial, Helvetica, sans-serif;
            }

            .print-batch {
              width: 210mm;
              margin: auto;
            }

            .print-page {
              page-break-after: always;
            }

            @page {
              size: A4;
              margin: 0;
            }
          </style>
        </head>
        <body>
          <div class="print-batch">
    `);

      ordersList.forEach((o) => {
        w.document.write(renderOrderHTML(o));
      });

      w.document.write(`
          </div>
        </body>
      </html>
    `);

      w.document.close();

      setTimeout(() => {
        w.focus();
        w.print();
      }, 500);

      return;
    }

    const pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    for (let i = 0; i < ordersList.length; i++) {
      const div = document.createElement("div");
      div.innerHTML = renderOrderHTML(ordersList[i]);
      div.style.width = "900px";
      div.style.background = "white";
      document.body.appendChild(div);

      await new Promise((r) => setTimeout(r, 300));

      const canvas = await html2canvas(div, {
        scale: 2,
        useCORS: true,
      });

      const img = canvas.toDataURL("image/jpeg", 0.8);
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;

      pdf.addImage(img, "JPEG", 0, 0, width, height);

      document.body.removeChild(div);

      if (i < ordersList.length - 1) pdf.addPage();
    }

    pdf.save(`Orders-${filterDate || "all"}.pdf`);
  };

  const getFilteredOrders = (status = null) => {
    let list = [...filtered];
    if (status) list = list.filter((o) => o.shipStatus === status);
    return list;
  };

  const [rangeStart, setRangeStart] = useState(1);
  const [rangeEnd, setRangeEnd] = useState(5);

  const printOrDownloadRange = (isPdf = false) => {
    const start = Math.max(1, Number(rangeStart)) - 1; // convert to index
    const end = Math.min(filtered.length, Number(rangeEnd)); // exclusive
    const ordersToPrint = filtered.slice(start, end);

    if (!ordersToPrint.length) return toast.error("No orders in this range");

    printOrDownloadBulk(ordersToPrint, isPdf);
  };
  const generateExcel = () => {
  if (!filtered.length) {
    return toast.warning("No orders to export");
  }

  const rows = [
    ["Si No", "Order Ref", "Customer", "Amount", "Date", "Status", "Shipping"],
  ];

  filtered.forEach((order, index) => {
    const orderDate = new Date(order.createdAt).toLocaleDateString("en-IN");
    rows.push([
      totalOrders - index,
      order.orderReference || "-",
      order.userId?.name || "Guest",
      order.amount,
      orderDate,
      order.paymentStatus,
      order.shipStatus || "-",
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Orders");

  XLSX.writeFile(
    wb,
    `Orders_${startDate || "all"}_to_${endDate || "all"}.xlsx`
  );
  toast.success("Orders exported to Excel! 📊");
};

  return (
    <div className="container-fluid mt-4">
      <ToastContainer />
      <div>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "4px 10px",
            fontSize: "12px",
            borderRadius: "6px",
            border: "1px solid #ddd",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          ← Back
        </button>
      </div>
      <div className="d-flex justify-content-between flex-wrap gap-2 mb-3">
        <h3 className="fw-bold">Order Management</h3>
     <div className="input-group" style={{ maxWidth: "200px" }}>
    <span className="input-group-text">From</span>
    <input
      type="date"
      className="form-control"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
  </div>

  {/* To */}
  <div className="input-group" style={{ maxWidth: "200px" }}>
    <span className="input-group-text">To</span>
    <input
      type="date"
      className="form-control"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>

  <div style={{ maxWidth: "250px" }}>
    <input
      type="text"
      className="form-control"
      placeholder="🔍 Search customer..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
      </div>

    <div className="d-flex flex-wrap gap-2 align-items-end">
 
</div>
      <div className="mb-3 d-flex flex-wrap gap-2">
        <button
          className="btn btn-primary"
          onClick={() => printOrDownloadBulk(getFilteredOrders(), false)}
        >
          Print All
        </button>
        <button
          className="btn btn-outline-primary"
          onClick={() => printOrDownloadBulk(getFilteredOrders(), true)}
        >
          PDF All
        </button>

        <button
          className="btn btn-warning"
          onClick={() =>
            printOrDownloadBulk(getFilteredOrders("processing"), false)
          }
        >
          Print Processing
        </button>
        <button
          className="btn btn-outline-warning"
          onClick={() =>
            printOrDownloadBulk(getFilteredOrders("processing"), true)
          }
        >
          PDF Processing
        </button>

        <button
          className="btn btn-success"
          onClick={() =>
            printOrDownloadBulk(getFilteredOrders("shipped"), false)
          }
        >
          Print Shipped
        </button>
        <button
          className="btn btn-outline-success"
          onClick={() =>
            printOrDownloadBulk(getFilteredOrders("shipped"), true)
          }
        >
          PDF Shipped
        </button>

        <button
  className="btn btn-success"
  onClick={generateExcel}
  disabled={!filtered.length}
>
  Export to Excel
</button>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <ReusableTable
            columns={columns}
            data={filtered}
            title="Order List"
            currentPage={currentPage}
            totalPages={totalPages}
            totalOrders={totalOrders}
            onChangePage={(page) => fetchOrders(page)}
          />
        </div>
      </div>

      {selectedOrder && (
        <div
          className="modal show fade d-block"
          style={{ background: "rgba(0,0,0,.5)" }}
          onClick={() => setSelectedOrder(null)}
        >
          <div
            className="modal-dialog modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content p-3">
              <div ref={invoiceRef} className="p-4 bg-white print-invoice">
                <div
                  dangerouslySetInnerHTML={{
                    __html: renderOrderHTML(selectedOrder),
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setSelectedOrder(null)}
                >
                  Close
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => printOrDownloadBulk([selectedOrder], false)}
                >
                  Print
                </button>
                <button
                  className="btn btn-outline-primary"
                  onClick={async () => {
                    await new Promise((r) => setTimeout(r, 300));

                    const canvas = await html2canvas(invoiceRef.current, {
                      scale: 1.6,
                      useCORS: true,
                    });

                    const img = canvas.toDataURL("image/jpeg", 0.72);

                    const pdf = new jsPDF({
                      orientation: "p",
                      unit: "mm",
                      format: "a4",
                      compress: true,
                    });

                    const width = pdf.internal.pageSize.getWidth();
                    const height = (canvas.height * width) / canvas.width;

                    pdf.addImage(img, "JPEG", 0, 0, width, height);
                    pdf.save(`Order-${selectedOrder.merchantOrderId}.pdf`);
                  }}
                >
                  PDF
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ordermanagement;
